import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Santiago_Hernandez
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */
/**
 * Custom con funciones adicionales al formulario de envasado produccion 
 **/
class CustomEnvasado extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm                                       = this.initForm.bind(this);
        this.successDatosFicha                              = this.successDatosFicha.bind(this);
        this.successConceptoFicha                           = this.successConceptoFicha.bind(this);
        this.successFichaEnvasadoFinal                      = this.successFichaEnvasadoFinal.bind(this);
        this.gridOptionsEnvasadoFinal                       = Object.assign({}, this.gridOptions);   
        this.setButtonGalonesEnvasados                      = this.setButtonGalonesEnvasados.bind(this);
        this.galonesEnvasadosChange                         = this.galonesEnvasadosChange.bind(this); 
        this.successGalonesEnvasados                        = this.successGalonesEnvasados.bind(this);
        this.uploadTbFichaEnvasadoFinal                     = this.uploadTbFichaEnvasadoFinal.bind(this);
        this.CorregirEnvasado                               = this.CorregirEnvasado.bind(this);
        this.successEnvasadoTotales                         = this.successEnvasadoTotales.bind(this);
        this.uploadEnvasadoTotales                          = this.uploadEnvasadoTotales.bind(this);
        this.setChangeButtonMatEmpaque                      = this.setChangeButtonMatEmpaque.bind(this);
        this.setChangeButtonMatEmpaqueClick                 = this.setChangeButtonMatEmpaqueClick.bind(this);
        this.successProductoTerminadoMatEmpq                = this.successProductoTerminadoMatEmpq.bind(this);
        this.gridOptionsPTMatEmpaque                        = Object.assign({}, this.gridOptions);  
        this.uploadModalMatEmpaque                          = this.uploadModalMatEmpaque.bind(this);
        this.setButtonCantAgregada                          = this.setButtonCantAgregada.bind(this);
        this.cantidadAgregadaChange                         = this.cantidadAgregadaChange.bind(this);
        this.successCantidadAgregadaMatEmpq                 = this.successCantidadAgregadaMatEmpq.bind(this);
        this.uploadProductoTerminado                        = this.uploadProductoTerminado.bind(this);
        this.terminarEnvasado                               = this.terminarEnvasado.bind(this);
        this.pasarEtapaAprobacion                           = this.pasarEtapaAprobacion.bind(this);
        this.confirmNoEnvasado                              = this.confirmNoEnvasado.bind(this);
        this.arrayTabla = [];
        this.bodyAux = {};
        this.verFormula                                     = this.verFormula.bind(this);
        this.successVerFormula                              = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula                          = Object.assign({}, this.gridOptions);
    }

    initForm(){
        console.log('Envasado, @version:1.01.0054 @author: Mario A. Sepúlveda R; @updateBy Sebastian Rios Echverri');

        this.getField('btnCorreccionEnvasado').setClick(this.CorregirEnvasado);
        this.getField('btnTerminar').setClick(this.terminarEnvasado);

        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'conceptoficha', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successConceptoFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });

        let datos2 = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'totalfichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos2,
            success: this.successEnvasadoTotales,
            error: this.error_,
            general: this.generalFormatPmv
        });

        this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'envasadofichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos2,
            success: this.successFichaEnvasadoFinal,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '450-Retorna_los_datos_de_la_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successDatosFicha,
                error:this.error_,
                general: this.generalFormat
            });

        this.generalFormat.nombre_accion = '450-Retorna_el_concepto_de_la_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successConceptoFicha,
                error:this.error_,
                general: this.generalFormat
            });

        this.generalFormat.nombre_accion = '450-Retorna_fichas_envasado_final_fichaid'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successFichaEnvasadoFinal,
                error:this.error_,
                general: this.generalFormat
            });

        this.generalFormat.nombre_accion = '450-Retorna_los_totales_del_envasado_final_por_el_id_de_la_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successEnvasadoTotales,
                error:this.error_,
                general: this.generalFormat
            });*/

        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.data;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    successDatosFicha(data){
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0){
            this.getField('listaItemsFicha').setVisible(true);
            this.getField('listaItemsFicha').setItemsFichas(data.data);
        }else{
            this.getField('listaItemsFicha').setVisible(false);
        }
    }

    successConceptoFicha(data){
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0){
            this.getField('conceptoFicha').setValue(data.data[0].descripcion);
        }
    }

    successFichaEnvasadoFinal(data){

        this.arrayTabla = data.data;
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0) {
            this.gridOptionsEnvasadoFinal['rowData']=[];
            this.getField('tbEnvasadoFichaFinal').initData(this.gridOptionsEnvasadoFinal);
            let configCell = new Map();
            configCell.set('cantidad_agregada',{cellRenderer:this.setButtonGalonesEnvasados,cellStyle: {backgroundColor: "rgb(238,238,238)",textAlign:"right",borderRadius:"5px",color:'rgb(0, 86, 201)'}, onCellValueChanged:this.galonesEnvasadosChange,width:100, editable: true, field: 'cantidad_agregada' });
            configCell.set('accion', {cellRenderer:this.setChangeButtonMatEmpaque, field:'Acción'});
            this.getField('tbEnvasadoFichaFinal').toggle(true);
            this.gridOptionsEnvasadoFinal['rowData'] = data.data;
            this.gridOptionsEnvasadoFinal.paginationPageSize = 100;
            this.getField('tbEnvasadoFichaFinal').initData(this.gridOptionsEnvasadoFinal, configCell);

        }else{ 
          this.getField('tbEnvasadoFichaFinal').toggle(false);
          this.getField('fieldAlert').toggle(true,"No hay envasado","error");
        } 
    }

    setButtonGalonesEnvasados(props){
        let valor_actual = props.data.cantidad_agregada;
        let div = document.createElement("div");
        let label = document.createElement("label");
        if(valor_actual !== null && valor_actual !== '' && valor_actual !== undefined && valor_actual >= 0 ){
            label.textContent = valor_actual;
            return "".formatoPrecio(props.data.cantidad_agregada); // se pone el formato precio a los datos editados en galones envasados
        }   
        else{
            label.textContent = 0;
        div.appendChild(label);
        return this.createElementJaivana(div);
        }
    }

    galonesEnvasadosChange(props){
        let seguir = this.getField('tbEnvasadoFichaFinal').cellValid(props.oldValue,props.newValue,'^[0-9]'); // Se valida que el dato ingresado sea un numero
        if (props.newValue < 0 ){
            props.data.cantidad_agregada = 0;
        }
        if(seguir){
            this.getField('cantidad_agregada').setValue(props.newValue);
            this.getField('id_cantidad_agregada').setValue(props.data.id);
            let datos = {
                datos:{
                    id: props.data.id,
                    cantidad_agregada: this.getField('cantidad_agregada').getValue(),
                    actividad_id:this.props.data.actividad_id
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'cantidadagregada', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successGalonesEnvasados,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '450-Permite_cambiar_la_cantidad_agregada'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'PUT',
                    body:body,
                    success:this.successGalonesEnvasados,
                    error:this.error_,
                    general: this.generalFormat
                });*/
        }
    }

    successGalonesEnvasados(response){

        this.uploadTbFichaEnvasadoFinal();
        if(response.estado_p === 200){
            this.getField('cantidad_agregada').setValue(' ');
            this.uploadEnvasadoTotales();
            this.uploadModalMatEmpaque();
        }
    }

    setChangeButtonMatEmpaque(props){
        let button = document.createElement("input");
        button.onclick = () => this.setChangeButtonMatEmpaqueClick(props.data);
        button.setAttribute("class","buttonStyle");
        button.setAttribute("type","button");
        button.setAttribute("value","Material empaque");
        return this.createElementJaivana(button); 
    }

    setChangeButtonMatEmpaqueClick(data){
        this.getField('modalMatEmpaque').handleClickOpen();
        this.getField('id_cantidad_agregada').setValue(data.id);
        let datos = {
            datos:{
                value: data.id, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'envasadofinalid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successProductoTerminadoMatEmpq,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '450-Retorna_material_empaque_producto_terminado'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successProductoTerminadoMatEmpq,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    successProductoTerminadoMatEmpq(data){
        if (data.estado_p === 200 && data.data !== undefined && data.data.length > 0) 
        {
            this.gridOptionsPTMatEmpaque['rowData']=[];
            this.getField('tbMatEmpaque').initData(this.gridOptionsPTMatEmpaque);
            let configCellCol = new Map();
            configCellCol.set('cantidad_agregada',{cellRenderer:this.setButtonCantAgregada,cellStyle: {backgroundColor: "rgb(238,238,238)",textAlign:"right",borderRadius:"5px",color:'rgb(0, 86, 201)'}, onCellValueChanged:this.cantidadAgregadaChange,width:100, editable: true, field: 'cantidad_agregada' });
            configCellCol.set('nombre_unidad',{width:70 ,field:'nombre_unidad'});
            this.getField('tbMatEmpaque').toggle(true);
            this.gridOptionsPTMatEmpaque['rowData'] = data.data;
            this.gridOptionsPTMatEmpaque.paginationPageSize = 100;
            this.getField('tbMatEmpaque').initData(this.gridOptionsPTMatEmpaque, configCellCol);

        }else{ 
          this.getField('tbMatEmpaque').toggle(false);
          this.getField('modalMatEmpaque').handleClose();
        } 
    }

    setButtonCantAgregada(props){
        let valor_actual = props.data.cantidad_agregada;
        let div = document.createElement("div");
        let label = document.createElement("label");
        if(valor_actual !== null && valor_actual !== '' && valor_actual !== undefined && valor_actual >= 0 ){
            label.textContent = valor_actual;
            return "".formatoPrecio(props.data.cantidad_agregada); // se pone el formato precio a los datos editados en galones envasados
        }   
        else{
            label.textContent = 0;
        div.appendChild(label);
        return this.createElementJaivana(div);
        }
    }

    cantidadAgregadaChange(props){
        let seguir = this.getField('tbMatEmpaque').cellValid(props.oldValue,props.newValue,'^[0-9]'); // Se valida que el dato ingresado sea un numero
        if (props.newValue < 0 ){
            props.data.agregar = 0;
        }
        if(seguir){
            this.getField('cantidad_agregada_matempq').setValue(props.newValue);
            let datos = {
                datos:{
                    id: props.data.id,
                    cantidad_agregada: this.getField('cantidad_agregada_matempq').getValue(),
                    actividad_id:this.props.data.actividad_id
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'cantidadagregada', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successCantidadAgregadaMatEmpq,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '450-Permite_actualizar_cantidad'; 
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'PUT',
                    body:body,
                    success:this.successCantidadAgregadaMatEmpq,
                    error:this.error_,
                    general: this.generalFormat
                });*/
        }
    }

    successCantidadAgregadaMatEmpq(){
        this.uploadProductoTerminado();
    }

    uploadTbFichaEnvasadoFinal(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'envasadofichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successFichaEnvasadoFinal,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*let body = {
            value: this.props.data.id_ficha, 
        }
        this.generalFormat.nombre_accion = '450-Retorna_fichas_envasado_final_fichaid'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successFichaEnvasadoFinal,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    uploadEnvasadoTotales(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'totalfichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successEnvasadoTotales,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '450-Retorna_los_totales_del_envasado_final_por_el_id_de_la_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successEnvasadoTotales,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    successEnvasadoTotales(data){
        this.getField('galones_resultantes').setValue(data.data[0].galones_resultantes);
        this.getField('total_cantidad_agregada').setValue(data.data[0].cantidad_agregada);
        this.getField('restante').setValue(data.data[0].restante);
    }

    uploadModalMatEmpaque(){
        this.getField('modalMatEmpaque').handleClickOpen();
        this.uploadProductoTerminado();
    }

    uploadProductoTerminado(){
        let datos = {
            datos:{
                value: this.getField('id_cantidad_agregada').getValue(), 
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadofinalmaterial', operacion: 'envasadofinalid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successProductoTerminadoMatEmpq,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '450-Retorna_material_empaque_producto_terminado'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successProductoTerminadoMatEmpq,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    CorregirEnvasado(){
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('btnCorreccionEnvasado').setDisabled(true);
        let datos = {
            datos:{
                id_formulario: this.formId,
                produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                proceso_id:this.getField('proceso_id').getValue(),
                actividad_id:this.getField('actividad_id').getValue(),
                actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'corregir', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.pasarEtapaAprobacion,
            error: this.error_,
            general: this.generalFormatPmv
        });
        
        /*this.generalFormat.nombre_accion = "450-Permite_pasar_a_la_de_Correcion_de_Envasado"; 
        this.service.send(
        {
            endpoint:this.constant.formConfiguration(),
            method:'POST',
            body:body,
            success:this.successCloseEstage,
            error:this.error_,
            general: this.generalFormat
        });*/
    }

    terminarEnvasado(){

        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        //let body = {}

        let cant = [];
        let seguir = false;
        let codigo ='';
        cant = this.arrayTabla.map((item)=>{
            codigo= item.codigo;
            return item.cantidad_agregada;
        });

        //console.log('cantidad agregada array',cant);
        seguir = cant.every(item => item !== 0)
        //console.log('valor',seguir);

        if(seguir){
            if(this.getField('observacion').getValue() === ''){
                this.getField('observacion').setValue('.');
            }
            this.bodyAux = {
                id_formulario: this.formId,
                produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                proceso_id:this.getField('proceso_id').getValue(),
                actividad_id:this.getField('actividad_id').getValue(),
                actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
                observacion:this.getField('observacion').getValue(),
            }
            //this.getField('observacion').setValue('');
            //console.log('entro al: IF');
            this.confirmNoEnvasado();
        } else if(this.getField('observacion').getValue() !== '' && this.getField('observacion').getValue !== ' '){
            this.bodyAux = {
                id_formulario: this.formId,
                produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                proceso_id:this.getField('proceso_id').getValue(),
                actividad_id:this.getField('actividad_id').getValue(),
                actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
                observacion:this.getField('observacion').getValue(),
            } 

            this.getField('confirmModalCustom').setTitleAndContent('¡ Material sin Envasar!', `No se envasará el ítem ${codigo}, desea continuar?`);
            this.getField('confirmModalCustom').setClickDialog(this.confirmNoEnvasado);
            this.getField('confirmModalCustom').toggle(true);
            //console.log('entro al: ELSEIF');
        } else{
            //console.log('entro al: ELSE');
            this.getField('observacion').setError(true,'Este campo es requerido');       
        }

    }

    confirmNoEnvasado(){
        this.getField('confirmModalCustom').toggle(false);
        let datos = {
            datos:this.bodyAux
        };

        this.getField('btnTerminar').setDisabled(true);


        this.generalFormatPmv = { tipo_servicio: 'prod-correccionenvasado', operacion: 'aprobar', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.pasarEtapaAprobacion,
            error: this.error_,
            general: this.generalFormatPmv
        });
       /*this.generalFormat.nombre_accion = "450-Permite_pasar_a_la_actividad_de_Aprobacion_de_produccion_envasado"; 
        this.service.send(
        {
            endpoint:this.constant.formConfiguration(),
            method:'POST',
            body:body,
            success:this.pasarEtapaAprobacion,
            error:this.error_,
            general: this.generalFormat
        }); */
    }
    pasarEtapaAprobacion(data){
        if(data.estado_p === 200){
            this.successCloseEstage(data);
        }else{
            this.getField('btnCorreccionEnvasado').setDisabled(false);
            this.getField('btnTerminar').setDisabled(false);
        }
    }

}
FormJaivana.addController("prod-envasado",CustomEnvasado);
export default CustomEnvasado;